<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Retailers List</h2> <router-link class="btn btn-secondary btn-sm" :to="{name:'retailers.create'}">Create New</router-link> 
            </div>
            <div class="col-md-6 text-right">
                <div class="btn btn-secondary btn-sm" v-on:click="print">Print Page</div>
            </div>
        </div>
        <form method="POST" novalidate @submit.prevent="getRetailers(1)">
            <div class="row mt-4">
                <div class="col-md-4 mb-2">
                    <input type="text" id="name" class="form-control"  placeholder="Name" v-model="params.name" :disabled="loading"> 
                </div>
                <div class="col-md-4 mb-2">
                    <select class="custom-select" id="retailerType" name="retailerType" v-model="params.retailerType" :disabled="loading">
                        <option :value="null">Retailer Type</option>
                        <option v-for="type in retailerTypes" :key="type.id" :value="type.id">
                            {{ type.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4 mb-2">
                    <select class="custom-select " id="force" name="force" v-model="params.force" :disabled="loading">
                        <option :value="null">Force</option>
                        <option v-for="force in forces" :key="force.id" :value="force.id">
                            {{ force.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-4 mb-2">
                    <select class="custom-select" id="lpa" name="lpa" v-model="params.lpa" :disabled="this.params.force == null || loading">
                        <option :value="null">LPA</option>
                        <option v-for="lpa in lpas" :key="lpa.id" :value="lpa.id">
                            {{ lpa.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4 mb-3">
                    <select class="custom-select" id="neighbourhood" name="neighbourhood" v-model="params.neighbourhood" :disabled="this.params.lpa == null || loading">
                        <option :value="null">Neighbourhood</option>
                        <option v-for="neighbourhood in neighbourhoods" :key="neighbourhood.id" :value="neighbourhood.id">
                            {{ neighbourhood.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-3 mb-2">
                    <button type="submit" class="btn btn-secondary" :disabled="loading">
                        Search
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>    
                    </button>
                    <button @click.prevent="reset" class="btn btn-link ml-3" :disabled="loading">Clear</button>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-sm-1 offset-md-11">
                    <select class="custom-select" id="results_count" name="results_count" v-model="params.count" v-on:change="getRetailers(1)">
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select> 
                </div>
            </div>
        </form>
        <div class="row justify-content-center mt-4">
            <table class="table table-responsive-md">
                <thead>
                    <tr><th scope="col">Name</th> <th scope="col">Address</th> <th scope="col">Last Visit</th> <th scope="col">Next Visit</th> <th scope="col">LPA</th> <th scope="col">CCTV</th> <th class="actions-col" scope="col">Actions</th></tr>
                </thead> 
                <tbody>
                    <tr v-for="retailer in retailers" :key="retailer.id" :class="retailer.closed_at != null ? 'muted' : retailer.risk_rating">
                        <td scope="row">{{retailer.retailer_name}}</td> 
                        <td scope="row" v-if="retailer.retailer_street && retailer.retailer_postcode">{{retailer.retailer_street}}, {{retailer.retailer_town}}, {{retailer.retailer_county}}, {{retailer.retailer_postcode}}</td> 
                        <td scope="row" v-else>No Address Available</td>
                        <td scope="row" class="text-nowrap">{{retailer.last_visit_date ? retailer.last_visit_date : '' }}</td> 
                        <td scope="row" class="text-nowrap">{{retailer.closed_at ? '' : retailer.next_visit_date}}</td> 
                        <td scope="row">{{retailer.lpa.name}}</td> 
                        <td scope="row">{{retailer.closed_at != null ? '' : retailer.has_cctv}}</td> 
                        <td class="actions-col text-no-wrap">
                            <div class="btn-group">
                                <router-link :to="{name: 'retailers.details', params: {id: retailer.id}}" class="btn btn-default py-0 px-1" v-tooltip="'Details'" v-if="!retailer.closed_at">
                                    <img src="../../../assets/svgs/Details-Icon.svg">
                                </router-link>
                                <div class="btn btn-default py-0 px-1" v-tooltip="'Closed'" v-else>
                                    <img src="../../../assets/svgs/Closed-Icon.svg">
                                </div>
                                <router-link :to="{name: 'retailers.edit', params:{id: retailer.id}}" class="btn btn-default py-0 px-1" v-tooltip="'Edit'">
                                    <img src="../../../assets/svgs/Edit-Icon.svg">
                                </router-link>
                                <router-link :to="{name: 'retailers.delete', params: {id: retailer.id}}" class="btn btn-default py-0 px-1"  v-tooltip="'Delete'">
                                    <img src="../../../assets/svgs/Delete-Icon.svg">
                                </router-link>
                                <div class="btn btn-default py-0 px-1" v-if="!retailer.retailer_email"  v-tooltip="'Missing Email'">
                                    <img src="../../../assets/svgs/Warning-Icon.svg">
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="12" class="text-center" v-if="retailers.length == 0">
                            No Results Found
                        </td>
                    </tr>

                </tbody>
            </table>
            <pagination :data="paginator" :limit="2" @pagination-change-page="getRetailers"></pagination>
        
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import pagination from "laravel-vue-pagination";
import CurrentUser from '../../../mixins/CurrentUser';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip);

export default {
    data: function () {
        return {
            loadingParams: false,
            params:{
                count: '10',
                name: null,
                force: null,
                lpa: null,
                neighbourhood: null,
                retailerType: null,
                page: 1,
            }
        }
    },

    mixins: [CurrentUser],

    components: { pagination },

    mounted() {
        if (window._.isEmpty(this.$route.query)) {
            this.params.force = this.currentUser.force_id;
            this.$store.dispatch('retailers/fetch', {params: this.params});
        } else {
            this.loadingParams = true;

            this.params = {...this.params, ...this.$route.query};

            this.params.name = this.params.name != null ? this.params.name : null;
            this.params.force = this.params.force != null ? parseInt(this.params.force) : null;

            setTimeout(this.loadParams, 600);
        }

        this.$store.dispatch('lpas/load');
        this.$store.dispatch('neighbourhoods/load');
        this.$store.dispatch('retailertypes/load');
        this.$store.dispatch('risks/load');
        this.$store.dispatch('productcategories/load');
    },

    watch: {
        'params.force': function () {
            if (!this.loadingParams) {
                this.params.lpa = null;
                this.params.neighbourhood = null;
            }
        },
        'params.lpa': function () {
            if (!this.loadingParams) {
                this.params.neighbourhood = null;
            }
        }
    },

    methods: {
        getRetailers: function (page) {
            this.params.page = page;
            this.$router.push({name: 'retailers.index', query: this.params}).catch(()=>{});
            this.$store.dispatch('retailers/fetch', {params: this.params});
            window.scrollTo(0,0);
        },

        print: function () {
            window.print();
        },

        loadParams: function () {
            this.params.lpa = this.$route.query.lpa;
            this.params.neighbourhood = this.$route.query.neighbourhood;

            this.$nextTick(() => {
                this.loadingParams = false;
                this.$store.dispatch('retailers/fetch', {params: this.params});
            });
        },

        reset: function () {
            this.params = {
                force: null,
                lpa: null,
                neighbourhood: null,
                retailerType: null,
                name: null,
                count: 10
            };
        }
    },
    computed: {
        retailers: function () {
            return this.$store.state.retailers.data;
        },
        paginator: function () {
            return this.$store.state.retailers.paginator;
        },
        forces: function () {
            return this.$store.state.forces.data;
        },
        lpas: function () {
            if (this.params.force === null) {
                return this.$store.state.lpas.data;
            }

            return this.forces.filter(force => force.id === this.params.force)[0].lpas;  
        },
        neighbourhoods: function () {
            if(this.params.force !== null && this.params.lpa === null) {
                return [];
            }
            
            if (this.params.lpa === null) {
                return this.$store.state.neighbourhoods.data;
            }

            return this.$store.state.neighbourhoods.data.filter(neighbourhood => neighbourhood.lpa_id == this.params.lpa);  
        },
        retailerTypes: function () {
            return this.$store.state.retailertypes.data;
        },
        loading: function () {
            return this.$store.state.retailers.loading;
        },
    }
}
</script>